import moment from "moment";

export const Columns=[
  {
    field: "createdAt",
    header: "Created At",
    accessor: (row,handleRowClick) => (
      <div   onClick={()=>handleRowClick(row,"createdAt")}  className="cursor-pointer text-blue-600 hover:text-blue-800">
        <p>{moment(row?.createdAt).utc().format("DD MMM YYYY hh:mma")}</p>
      </div>
    ),
  },
    { field: "regionType", header: "Region",
      accessor: (row,handleCellClick) => (
        <>
          <div>          
            <p className="w-[6rem]">
              {row?.regionType?.regionType|| ""}
            </p>
          </div>
        </>
      ),
     },
    { field: "deliveryType", header: "Delivery Type",
      accessor: (row) => (
        <>
          <div   className="">          
            <p className="w-[6rem]">
              {row?.deliveryType?.name || ""}
            </p>
          </div>
        </>
      ),
     },
    { field: "vehicleType", header: "Vehicle Type",
      accessor: (row) => (
        <>
          <div   className="">          
            <p className="w-[6rem]">
              {row?.vehicleType || ""}
            </p>
          </div>
        </>
      ),
     },
  ]

  export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export const filters = [
    // {
    //   filterType: "Rating",
    //   inputName: "rating",
    //   options: [
    //     {
    //       name: "5",
    //       code: "5",
    //     },
    //     {
    //       name: "4",
    //       code: "4",
    //     },
    //     {
    //       name: "3",
    //       code: "3",
    //     },
    //     {
    //       name: "2",
    //       code: "2",
    //     },
    //     {
    //       name: "1",
    //       code: "1",
    //     },
       
    //   ],
    // },
   
  ];
  
  
  export const canlenderFilter={
    filterType:"Review Date",
    inputName:"createdAt",  
    maxDate :new Date()
  }